import { mediaItems } from '@/mocks/homepage';

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900">热门视频</h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">热舞、街拍、精选视频一次看过瘾</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors duration-200 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between">
                  <span className="px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="px-2 py-0.5 bg-black/60 text-white text-xs rounded whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
                <div className="absolute top-2 right-2 w-10 h-10 flex items-center justify-center bg-white/90 rounded-full">
                  <i className="ri-play-fill text-primary-500 text-lg ml-0.5"></i>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1 line-clamp-2">{item.title}</h3>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}